import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import ButtonV2 from "../../shared/components/buttonV2";
import { PHONE_CALL } from "../../assets";
// @ts-ignore
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl,
  shadowurl: iconShadow,
});
function Contact() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px -100px 0px" });
  return (
    <div id="contact" className="w-full lg:h-[630px] h-[1100px] relative">
      {/* Map Layer */}
      <MapContainer
        center={[6.4281, 3.4216]}
        zoom={12}
        scrollWheelZoom={false}
        className="absolute inset-0 z-0"
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.title.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[6.4281, 3.4216]}>
          <Popup>Lispendes Property.</Popup>
        </Marker>
      </MapContainer>

      {/* Overlay */}
      <div className="absolute inset-0 bg-[#00000099] z-10"></div>

      {/* Contact Card and Form */}
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 60 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1, ease: "easeOut" }}
        className="lg:w-[70vw] w-[90vw] mt-16 absolute bottom-10 z-40 lg:p-16 p-5 rounded-sm gap-x-5 lg:right-1/4 right-5 lg:space-x-4 space-y-4 shadow-lg bg-white flex items-start lg:flex-row flex-col justify-center"
      >
        {/* Contact Info Card */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 1.1, ease: "easeOut", delay: 0.3 }}
          className="lg:w-[480px] w-full h-full p-5 flex flex-col gap-y-5 rounded-lg bg-globalGold"
        >
          <div className="flex flex-col gap-y-3 items-start text-white">
            <span className="text-[16px] font-bold">Our Location</span>
            <span className="text-sm font-medium">
              Judiciary Complex, Independence Layout, Anambra, Nigeria
            </span>
          </div>

          <div className="flex flex-col gap-y-3 items-start text-white">
            <span className="text-[16px] font-bold">Quick Contact</span>
            <span className="text-sm font-medium">
              Email: support@lispensens.an.gov.ng
            </span>
            <span className="text-sm font-medium">
              Support: registry@lispensens.an.gov.ng
            </span>
          </div>

          <span className="text-sm text-white font-medium">
            We will respond within 24 hours, or call us during weekdays, 09:00
            AM – 05:00 PM
          </span>

          <div className="flex items-center gap-x-3 text-white">
            <img
              src={PHONE_CALL}
              className="w-[30px] h-[30px]"
              alt="Call Icon"
            />
            <span className="text-[16px] font-bold"> +234 809 4906 0890</span>
          </div>
        </motion.div>

        {/* Contact Form */}
        <div className="w-full h-full flex flex-col items-start gap-y-5">
          <span className="font-bold text-2xl">Contact Us</span>
          <span className="text-sm text-[#9B9B9B] font-medium">
            We're here to assist you with property search inquiries, status
            clarifications, or court-upload support. Please fill out the form
            below and we’ll respond promptly.
          </span>

          <div className="flex flex-col items-start gap-y-3 w-full">
            <span className="text-sm font-semibold">Personal Details</span>
            <div className="w-full flex lg:flex-row flex-col gap-5">
              <input
                type="text"
                placeholder="Name (Your Full Name)"
                className="outline-none text-sm placeholder:text-[#808080] border border-[#E9EAEB] p-3 lg:w-[230px] w-full"
              />
              <input
                type="text"
                placeholder="Email (Your email address)"
                className="outline-none text-sm placeholder:text-[#808080] border border-[#E9EAEB] p-3 lg:w-[230px] w-full"
              />
            </div>
            <textarea
              rows={4}
              placeholder="Message here"
              className="outline-none  resize-none text-sm placeholder:text-[#808080] border border-[#E9EAEB] p-3 w-full"
            />
          </div>

          <ButtonV2
            title="Send"
            handleClick={() => {}}
            btnStyle="px-8 py-3 bg-globalGold w-fit px-5 flex self-end py-3 rounded-full"
            textStyle="text-white font-medium text-[16px]"
          />
        </div>
      </motion.div>
    </div>
  );
}

export default Contact;
